import {Component, OnInit, AfterViewInit, Output, EventEmitter, Input, ElementRef, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {StocksToolbarSettings} from "../../models/stocks-toolbar-settings";
import {MainHelper} from "../../models/main-helper";
import {OnDropdownFilteredEventArgs} from "../../../slick-grid/models/on-dropdown-filtered-event-args";
import {AggregationSelector} from "../../../stocks/models/aggregation-selector";
import {StocksToolbarHelper} from "../../models/stocks-toolbar-helper";


@Component({
    selector: 'stocks-toolbar',
    templateUrl: './stocks-toolbar.component.html',
    styleUrls: ['./stocks-toolbar.component.css']
})
export class StocksToolbarComponent implements OnInit, AfterViewInit{

    constructor(public readonly translateService: TranslateService,
                ){
        this.locale = localStorage['UserLocale'];
        this.emitEvent  = new EventEmitter();
        this.helper = new MainHelper();
    }

    @Input() popperWrapper: HTMLElement;
    @Input() popperWrapperId: string;
    // @Input() settings: StocksToolbarSettings[];
    @Input() tbh: StocksToolbarHelper;


    /*@Input('gridFilters')
    set gridFilters(val: OnDropdownFilteredEventArgs<any>[]){
        this._gridFilters = val;
    }

    get gridFilters(): OnDropdownFilteredEventArgs<any>[]{
        return this._gridFilters
    }

    @Input('grouping')
    set grouping(val: Slick.Data.GroupingOptions<any>[]){
        this._grouping = val;
    }

    get grouping(): Slick.Data.GroupingOptions<any>[]{
        return this._grouping
    }

    @Input('aggregations')
    set aggregations(val:  AggregationSelector[]){
        this._aggregations = val;
    }

    get aggregations():  AggregationSelector[]{
        return this._aggregations
    }

    @Input()
    set toolbarHidden(val: boolean){
        this._toolbarHidden = val;
    }

    get toolbarHidden(): boolean{
        return this._toolbarHidden
    }

    @Input()
    set updateButtons(val: any){
        // this._toolbarHidden = val;
    }

    // get updateButtons(): any{
    //     return {}
    // }*/

    get language(): string{
        return this.locale;
    }

    set language(value: string){
        this.locale = value;
        localStorage['UserLocale'] = value;
    }

    @Output() emitEvent: EventEmitter<any>;

    private locale: string;
    private _toolbarHidden: boolean;
    public helper: MainHelper;
    public dataWorkZone: boolean;
    private _gridFilters: OnDropdownFilteredEventArgs<any>[];
    private _grouping: Slick.Data.GroupingOptions<any>[];
    private _aggregations:  AggregationSelector[];

    @ViewChild('addGroupingBtn')
    public addGroupingBtnRef: ElementRef;

    @ViewChild('addAggregationBtn')
    public addAggregationBtnRef: ElementRef;

    @ViewChild('remFiltersBtn')
    public remFiltersBtnRef: ElementRef;

    ngOnInit(){

    }

    ngAfterViewInit(){

    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/stocks-toolbar.component/stocks-toolbar.component.ts